// extracted by mini-css-extract-plugin
export var notificationHost = "_lr-0";